import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .me()
      .then((d) => setUser(d.user))
      .catch(() => setUser(null))
      .finally(() => setLoading(false));
  }, []);

  const login = useCallback(async (credentials) => {
    const res = await api.login(credentials);
    if (res.ok) setUser(res.data.user);
    return res;
  }, []);

  const signup = useCallback(async (attrs) => {
    const res = await api.signup(attrs);
    if (res.ok) setUser(res.data.user);
    return res;
  }, []);

  const logout = useCallback(async () => {
    await api.logout();
    setUser(null);
  }, []);

  const verifyOtp = useCallback(async (code) => {
    const res = await api.otpVerify(code);
    if (res.ok) setUser(res.data.user);
    return res;
  }, []);

  const resendOtp = useCallback((channel) => api.otpResend(channel), []);

  const value = {
    user,
    loading,
    isAuthenticated: !!user,
    isConfirmed: !!user?.confirmed,
    login,
    signup,
    logout,
    verifyOtp,
    resendOtp,
  };
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
